const PEOPLE = {
	GET_PEOPLE: 'GET_PEOPLE',
	GET_PEOPLE_SUCCESS: 'GET_PEOPLE_SUCCESS',
	GET_PEOPLE_FAILURE: 'GET_PEOPLE_FAILURE'
}

export { PEOPLE }